import React from 'react';
import { ListReplyWrapper, ListReplyText } from './MessageListReply.styled';

type MessageListReplyProps = { title?: string };

export function MessageListReply({ title }: MessageListReplyProps) {
  if (!title) return null;
  return (
    <ListReplyWrapper>
      <span>↩</span>
      <ListReplyText>{title}</ListReplyText>
    </ListReplyWrapper>
  );
}
